<template>
  <div class="container text-center mt-5">
    <div class="row login-block">
      <div class="col">
        <h2 class="text-primary">Single Sign-On</h2>
      </div>
    </div>

    <div class="row login-block">
      <div class="w-100 d-flex justify-content-center">
        <div class="w-100 mt-1 text-secondary text-center font-18">
          Please select account that you want to use
        </div>
      </div>
    </div>
    <section class="mb-5 w-100">
      <table class="table companies-table d-flex flex-wrap">
        <thead class="w-100">
          <tr class="font-weight-bold text-secondary font-14 pl-4">
            <th scope="col" class="text-left company-name">COMPANY NAME</th>
          </tr>
        </thead>
        <tbody class="w-100">
          <tr class="w-100">
            <td>
              <input
                type="search"
                class="form-control input-search"
                placeholder="Search"
                name="companyName"
                v-model="filterSearch"
              />
            </td>
            <td class="role-column">&nbsp;</td>
            <td class="select-column"></td>
          </tr>
          <tr v-for="(company, index) in filteredCompanies" :key="company.id" class="w-100">
            <td>
              <div class="select-company-block d-flex">
                <div class="select-company-img">
                  <img alt="logo" :src="logoPathStart + company.companyId" />
                </div>
                <div class="ml-3">
                  <div>
                    <a
                      href="javascript:void(0)"
                      class="company-name-link text-left"
                      v-b-modal="'bv-modal-profile'"
                      @click="profileCarrierId = company.id"
                      ><b>{{ company.name }}</b></a
                    >
                    <div
                      class="badge badge-broker ml-2"
                      v-if="company.isBroker"
                    >
                      Broker
                    </div>
                  </div>
                  <div class="text-left">
                    <a
                      class="company-name-link font-12"
                      :href="'http://' + company.url"
                      >{{ company.url }}</a
                    >
                  </div>
                  <div
                    class="description text-secondary"
                    v-on:click="
                      company.showDescription = !company.showDescription
                    "
                    :class="{ 'full-description': company.showDescription }"
                  >
                    {{ company.description }}
                  </div>
                </div>
              </div>
            </td>
            <td class="align-middle position-relative p-0 select-block-user-id">
              <div class="position-absolute" style="top: 12px;">
                <multiselect
                    @input="
                    (item) => {
                      onChangeRole(item, company.id);
                    }"
                    :open-direction="getDirectionDropDownPosition(index)"
                    v-model="value[company.id]"
                    label="codeName"
                    v-if="allowedRolesTypes[company.id] != null"
                    :options="allowedRolesTypes[company.id]"
                    class="role-select"
                    track-by="userId"
                    :valueProp="'userId'"
                    placeholder="Select Role"
                    select-label=""
                    :hide-selected="true"
                    deselect-label=""
                    name="codeName"
                    :multiple="false"
                    :searchable="false"
                    :taggable="true"
                    data-testid ="account-admin-selector"
                >
                </multiselect>
              </div>
            </td>
            <td class="align-middle">
              <button
                type="button"
                class="btn btn-block btn-sm user-select-btn"
                :disabled="isCheckRoleSelectValue(company.id)"
                :class="{
                  'btn-success': company.selected,
                  'btn-info': !company.selected
                }"
                @click="toggleSelection(company)"
                data-testid="select-account-button"
              >
                {{ getSelectionText(company) }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { required } from 'vuelidate/lib/validators';
import { MUTATION_REGISTRATION_EMAIL } from '../constants';
import loginComponentMixin from './loginComponentMixin';
import { mapActions, mapGetters, mapState } from 'vuex';
import { loginStore } from '../loginStore';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [WdxBaseComponentMixin, loginComponentMixin],
  data() {
    return {
      rolesTypes: [],
      allowedRolesTypes: [],
      companies: [],
      logoPathStart:
        process.env.VUE_APP_WEB_SITE_URL +
        'CompanyLogo.aspx?height=40&width=80&cid=',
      filterSearch: '',
      profileCompanyId: null,
      value: [],
      renderIterator: 1
    };
  },
  mounted: function () {
    this.loadCompanies();
  },
  computed: {
    ...mapGetters([
      'registrationEmail',
      'registrationUserFullName',
      'registrationUserId'
    ]),
    filteredCompanies: function () {
      this.renderIterator = this.renderIterator;
      const search = this.filterSearch.trim().toLowerCase();

      let companyResult = this.companies.filter((company) => {
        if (
          (search && company.name.toLowerCase().indexOf(search) >= 0) ||
          !search
        ) {
          return true;
        }
        return false;
      });

      return companyResult;
    }
  },
  watch: {},
  methods: {
    ...mapActions(['loadRegistrationUsers']),
    onChangeRole(selectedItem, id) {
      this.renderIterator++;
    },
    getDirectionDropDownPosition(index) {
      if(index != this.filteredCompanies.length - 1){
        return "bottom";
      }
      return "top";
    },
    isCheckRoleSelectValue(id) {
      return this.value[id] != null ? false : true;
    },
    getSelectionText(company) {
      return 'Select';
    },
    toggleSelection(company) {
      const userId = this.value[company.id].userId;
      this.$userService
        .loginUserById(userId)
        .then((response) => {
          if (response.data) {
            const res = response.data;
            if (res.Error) {
              this.notification = res.Error;
            } else if (res.CookieValue) {
              const expDate = new Date(res.CookieExpiration);
              document.cookie = `${res.CookieName}=${res.CookieValue}; path=${
                res.CookiePath
              }; samesite=${
                res.CookieSameSite
              }; expires=${expDate.toUTCString()}; secure=false;`;
              const redirectUrl = this.getRedirectUrl(res.DefaultUrl);
              window.location = redirectUrl;
            } else {
              this.notification = 'There is an error.';
            }
          }
        })
        .catch((error) => {
          this.loginLoading = false;
          this.handleHttpError(error, true);
        });
    },
    getRoleFromPrivilegeCode(userPrivilegeCode) {
      return this.rolesTypes.find(
        (roleType) => roleType.value == userPrivilegeCode
      );
    },
    loadCompanies() {
      this.showLoading();
      const email = this.registrationEmail;
      if (email == null || email === undefined) {
        this.hideLoading();
        this.$router.push({ name: 'emailInput' });
        return;
      }
      this.hideLoading();
      this.loadRegistrationUsers(email)
        .then((response) => {
          this.loginLoading = false;
          this.rolesTypes = response.roles;
          this.companies = response.companies.map((company) => {
            return {
              id: `${company.companyId}-${company.accountId}`,
              name: company.name,
              url: company.url,
              companyId: company.companyId,
              accountId: company.accountId,
              isBroker: company.isBroker,
              description: company.description,
              users: company.users
            };
          });
          this.companies.forEach((company) => {
            if (this.allowedRolesTypes[company.id] == null) {
              this.allowedRolesTypes[company.id] = [];
            }
            company.users.forEach((user) => {
              const role = this.getRoleFromPrivilegeCode(
                user.userPrivilegeCode
              );
              this.allowedRolesTypes[company.id].push({
                code: role == null ? null : role.code,
                codeName: role == null ? null : role.codeName,
                value: user.userPrivilegeCode,
                userId: user.userId
              });
            });
          });
        })
        .catch((error) => {
          this.loginLoading = false;
          this.handleHttpError(error, false);
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');

td.role-column {
  width: 180px;
}
.role-select {
  min-width: 180px;
  max-width: 180px;
  max-height: 42px;
}
.multiselect__option--highlight {
  background: #aaa !important;
}

.multiselect__tag {
  background: #aaa;
  color: #fff;
  margin-bottom: 0;
}

.multiselect__tags {
  border-radius: 2px;
  padding: 6px 40px 0 8px;
  max-height: 42px;
  border: 1px solid #acb8c5;
  font-size: 0.8rem;
}

.multiselect__tag-icon {
  background: #aaa;
}

multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__single {
  font-family: Poppins !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 28px;
  color: #adadad;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #888;
}

.multiselect__select:before {
  top: 80%;
}

.multiselect__placeholder {
  font-family: Poppins !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 28px;
  color: #adadad;
  padding: 0 0 0 5px;
}

input[name='companyName']::placeholder {
  font-family: Segoe UI !important;
  font-style: normal;
  font-weight: normal;
  color: #111111;
  font-size: 14px;
}

.multiselect__select {
  position: absolute;
  width: 40px;
  height: 40px;
  z-index: 1;
  right: revert;
  top: revert;
  padding: 14px 8px;
  text-align: center;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0s ease, -webkit-transform 0s ease;
}
.tbody {
  display: inline-table;
}

.multiselect__select:before {
  position: relative;
  top: 14%;
  right: -583%;
  color: #999;
  margin-top: 4px;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 0px 0px 0;
  content: url("data:image/svg+xml,%3Csvg width='22' height='12' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23979797'/%3E%3C/svg%3E");
}

.multiselect__content-wrapper {
  min-height: 0px !important;
  min-width: 180px;
  max-width: 180px;
  line-height: 0px;
}

.select-column {
  width: 118px;
}

.btn-info {
  background: #dff0f8;
  border-radius: 5px;
  width: 118px;
}

.user-select-btn {
  min-width: 180px;
  max-width: 180px;
}
.multiselect--active .multiselect__select:before {
  right: 583%;
  top: -30%;
}
.company-name {
  font-family: Poppins !important;
  font-style: normal;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  color: #565656;
}

.company-name-link {
  font-family: Poppins !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  font-weight: 300;
  color: #565656;
}

.companies-table {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.companies-table tbody {
  display: inline-table;
}
.input-search {
  width: 312px;
}
.select-block-user-id {
  min-width: 180px;
}
</style>
